/* @flow */
import type { PlaybackStatus, ReduxState, Action, SimplifiedTrack } from '../../types';

// ===========================
//   STATE TYPE
// ===========================
export type PlayerQueueState = {
  tracks: SimplifiedTrack[],
  isPlayerQueueVisible: boolean,
  currentTrackIndex: number,
  currentTrackId: number,
  playbackStatus: PlaybackStatus,
  requestedPlaybackStatus?: PlaybackStatus,
};

// ===========================
//   INITIAL STATE
// ===========================
export const initialState: PlayerQueueState = {
  tracks: [],
  isPlayerQueueVisible: false,
  currentTrackIndex: 0,
  currentTrackId: 0,
  playbackStatus: 'PAUSED',
  requestedPlaybackStatus: 'PAUSED',
};

// ===========================
//   REDUCER
// ===========================
export default (state: PlayerQueueState = initialState, action: Action): PlayerQueueState => {
  switch (action.type) {
    case 'TOGGLE_PLAYER_QUEUE_VISIBILITY':
      return { ...state, isPlayerQueueVisible: !state.isPlayerQueueVisible };
    case 'LOGOUT_SUCCESS':
      return initialState;
    case 'CLEAR_TRACKS':
      return {
        ...state,
        playbackStatus: 'PAUSED',
        requestedPlaybackStatus: 'PAUSED',
        tracks: [],
      };

    case 'SET_CURRENT_TRACK':
      return {
        ...state,
        currentTrackIndex: action.payload.currentTrackIndex,
        currentTrackId: action.payload.currentTrackId,
      };

    case 'SET_PLAYBACK_STATUS':
      return { ...state, playbackStatus: action.payload };

    case 'PLAY_TRACKS':
      if (
        state.tracks.length &&
        state.tracks[state.tracks.length - 1].id === action.payload[0].id &&
        state.requestedPlaybackStatus !== 'ERROR'
      ) {
        return {
          ...state,
          requestedPlaybackStatus:
            state.requestedPlaybackStatus === 'PLAYING' ? 'PAUSED' : 'PLAYING',
        };
      } else {
        const tracks = [...state.tracks, ...action.payload];
        let status = 'PLAYING';
        let nextTrack = action.payload[0];
        const nextTrackIndex = state.tracks.length;
        const nextTrackId = nextTrack.id;
        return {
          ...state,
          currentTrackId: nextTrackId,
          currentTrackIndex: nextTrackIndex,
          requestedPlaybackStatus: status,
          tracks,
        };
      }

    default:
      return state;
  }
};

// ===========================
//   SELECTORS
// ===========================
export const getIsPlaying = (state: ReduxState): boolean => {
  return state.playerQueue.playbackStatus === 'PLAYING';
};
